import React from 'react';
import { OrderFormCartLoading } from './OrderFormCartLoading';

export const OrderFormLoading = () => {
    return (
        <div className="order-form-loading">
            <div className="row">
                <div className="col-12 col-xl-4 mb-3">
                    <div className="placeholder-glow">
                        <span className="placeholder placeholder-sm col-3 mt-1 mb-2"></span>
                        <span className="placeholder placeholder-lg w-100 mt-1 mb-2"></span>
                    </div>
                </div>
                <div className="col-12 col-xl-4 mb-3">
                    <div className="placeholder-glow">
                        <span className="placeholder placeholder-sm col-3 mt-1 mb-2"></span>
                        <span className="placeholder placeholder-lg w-100 mt-1 mb-2"></span>
                    </div>
                </div>
                <div className="col-12 col-xl-4 mb-3">
                    <div className="placeholder-glow">
                        <span className="placeholder placeholder-sm col-3 mt-1 mb-2"></span>
                        <span className="placeholder placeholder-lg w-100 mt-1 mb-2"></span>
                    </div>
                </div>
                <div className="col-12 mb-3">
                    <OrderFormCartLoading />
                </div>
            </div>
            <div className="row mb-3">
                <div className="d-grid order-1 order-sm-0 col-sm-6 col-md-4 col-lg-3 mb-3 mb-sm-0">
                    <span className="btn btn-secondary disabled placeholder mb-2"></span>
                </div>
                <div className="d-grid order-0 order-sm-1 col-sm-6 col-md-4 col-lg-3 offset-md-4 offset-lg-6 mb-3 mb-sm-0">
                    <span className="btn btn-primary disabled placeholder mb-2"></span>
                </div>
            </div>
        </div>
    );
};
